import { styled, Table } from '@mui/material';
export const TableWithMobileView = styled(Table)(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        minWidth: '100%',
        '& > tbody > tr > td': {
            display: 'block!important',
            width: 'auto!important',
            position: 'relative',
            lineHeight: '1rem',
            padding: '5px',
            border: '0',
            '&:last-child': {
                borderBottom: '1px solid rgba(0, 0, 0, 0.25)',
                paddingBottom: theme.spacing(2),
            },
            '&:first-of-type': {
                paddingTop: theme.spacing(2),
            },
        },
        '& .MuiTableRow-head': {
            display: 'none',
        },
    },
}));
